import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {z as zod} from "zod";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export enum UserDetailStatus {
    active = "6a3c8de6-77b7-4e26-a963-ac22c75c0a52",
    deleted = "603c0fed-24fd-4072-b371-915329aaab38",
}

export type UserDetails = {
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    email: string | null;
    id: Uuid;
    name: string | null;
    phoneNumber: string | null;
    status: UserDetailStatus;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
    userId: Uuid;
};

export const userDetailsValidator: zod.ZodType<UserDetails> = zod.object({
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    email: zod.string().nullable(),
    id: uuidZodValidator,
    name: zod.string().nullable(),
    phoneNumber: zod.string().nullable(),
    status: zod.enum(UserDetailStatus),
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
    userId: uuidZodValidator,
});
